<div class="bg-wrapper sign-in pt-2">
    <header class="mb-2 container">
        <span class="brand"
            ><img src="assets/images/jsw-logo.png" alt="jsw-logo"
        /></span>
    </header>

    <main class="container justify-content-center py-4">
        <div class="row">
            <div class="col-md-6">
                <div class="value-prop-pane pt-4">
                    <div
                        id="valuePropSlides"
                        class="carousel slide"
                        data-bs-ride="carousel"
                    >
                        <div class="carousel-inner">
                            <div class="carousel-item active">
                                <h2>WELCOME TO THE JSW VENDOR PORTAL</h2>
                                <p>
                                    Manage your daily interactions and
                                    collaborate with JSW in real time
                                </p>
                            </div>
                            <div class="carousel-item">
                                <h2>
                                    MAXIMIZE OPERATIONAL EFFICIENCY AND
                                    EFFECTIVENESS
                                </h2>
                                <ul>
                                    <li>
                                        Submit and automatically validate your
                                        invoices;
                                    </li>
                                    <li>
                                        Speed up the dispute management process.
                                    </li>
                                </ul>
                            </div>
                            <div class="carousel-item">
                                <h2>GAIN REAL-TIME BUSINESS INSIGHTS</h2>
                                <ul>
                                    <li>
                                        Track your invoices from submission to
                                        payment;
                                    </li>
                                    <li>
                                        Get quick access to all relevant
                                        information in one place.
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="carousel-indicators">
                            <button
                                type="button"
                                data-bs-target="#valuePropSlides"
                                data-bs-slide-to="0"
                                class="active"
                                aria-current="true"
                                aria-label="Slide 1"
                            ></button>
                            <button
                                type="button"
                                data-bs-target="#valuePropSlides"
                                data-bs-slide-to="1"
                                aria-label="Slide 2"
                            ></button>
                            <button
                                type="button"
                                data-bs-target="#valuePropSlides"
                                data-bs-slide-to="2"
                                aria-label="Slide 3"
                            ></button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-6">
                <div class="row">
                    <div class="col-md-10 offset-md-2">
                        <div class="form-container">
                            <h3 class="mb-3">Login</h3>
                            <p class="mb-3">
                                Welcome, enter your login details below to
                                access your account
                            </p>

                            <form
                                [formGroup]="loginData"
                                (ngSubmit)="onLogin()"
                            >
                                <p *ngIf="isError" class="help-block">
                                    <span
                                        ><i class="ri-error-warning-fill"></i
                                    ></span>
                                    Sorry, incorrect Vendor Code or Password
                                </p>
                                <p *ngIf="isServerError" class="help-block">
                                    <span
                                        ><i class="ri-error-warning-fill"></i
                                    ></span>
                                    Sorry, your request could not be processed.
                                    Please contact JSW Admin
                                </p>
                                <div class="mb-3">
                                    <label class="form-label"
                                        >Vendor Code</label
                                    >
                                    <p
                                        class="help-block"
                                        *ngIf="
                                            !loginData.get('userName')?.valid &&
                                            loginData.get('userName')?.touched
                                        "
                                    >
                                        Vendor Code is required
                                    </p>
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="vendor_code"
                                        placeholder="Eg. ALWPG5809L"
                                        formControlName="userName"
                                    />
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">Password</label>
                                    <p
                                        class="help-block"
                                        *ngIf="
                    loginData.get('password')?.errors?.['required'] &&
                    loginData.get('password')?.touched
                    "
                                    >
                                        Password is required
                                    </p>
                                    <input
                                        type="password"
                                        class="form-control"
                                        id="activation_password"
                                        placeholder="Eg. 100XX622T0"
                                        formControlName="password"
                                    />
                                </div>
                                <button
                                    [disabled]="loginData.invalid"
                                    type="submit"
                                    class="btn btn-primary"
                                >
                                    Login
                                </button>
                                <div
                                    class="loader text-center mt-3"
                                    *ngIf="isLoading"
                                >
                                    Loading ...
                                </div>
                            </form>
                            <div class="forgot-password-pane mt-3">
                                <p>
                                    Forgot Password?
                                    <a routerLink="/reset-password"
                                        >Reset Password</a
                                    >
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>

    <footer class="mt-auto d-flex justify-content-center">
        <p>
            Powered by
            <span class="brand-payex"
                ><img src="assets/images/payex-logo.png" alt="PayExLogo"
            /></span>
        </p>
    </footer>
</div>
